import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { guidFor } from '@ember/object/internals';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("{{yield (hash\n  characters = this.characters\n  editor=(component \"quill-editor\"\n    id=this.editorId\n    onLength=this.setLength\n    onWords=this.setWords\n    _toolbar=(concat \"#\" this.toolbarId)\n  )\n  length=this.length\n  toolbar=(component \"quill/toolbar\"\n    id=this.toolbarId\n  )\n  words=this.words\n)}}\n");

var _class, _descriptor, _descriptor2, _descriptor3;
let QuillComponent = (_class = class QuillComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "length", _descriptor, this);
    _initializerDefineProperty(this, "characters", _descriptor2, this);
    _initializerDefineProperty(this, "words", _descriptor3, this);
  }
  get id() {
    return guidFor(this);
  }
  get toolbarId() {
    return `${this.id}-toolbar`;
  }
  get editorId() {
    return `${this.id}-editor`;
  }
  setLength(length) {
    this.length = length;
    this.characters = length - 1;
  }
  setWords(words) {
    this.words = words;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "length", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "characters", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "words", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "setLength", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setLength"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setWords", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setWords"), _class.prototype), _class);
setComponentTemplate(TEMPLATE, QuillComponent);

export { QuillComponent as default };
//# sourceMappingURL=quill.js.map
